import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './chip.css';

/**
 * @typedef {'primary' | 'gradient' | 'accent' | 'warning' | 'success' | 'info' | 'category-01' | 'category-02' | 'category-03' | 'category-04' | 'category-05' | 'category-06'} ChipVariant
 */

/**
 * @property {ChipVariant} variant
 * @property {'sm' | 'md' | 'lg'} size
 * @property {string} text
 * @property {boolean} border
 */
export default class Chip extends TemplateElement {
    constructor() {
        super({ styles: [style], propertyOptions: { variant: { reflect: true }, border: { reflect: true } } });
    }

    properties() {
        return {
            variant: '',
            size: 'md',
            text: '',
            border: true,
        };
    }

    template() {
        return html`${this.text}`;
    }
}

defineElement('mb-chip', Chip);
